<div [ngClass]="['timeline-container', sectionclass !== undefined ? sectionclass : '']">
	<h2 class="section-header" *ngIf="sectiontitle !== undefined">
		{{ sectiontitle }}
	</h2>
	<app-days-filter-r10
		[daysButton]="buttons?.days"
		[weeksButton]="buttons?.weeks"
		[monthsButton]="buttons?.months"
		[applyNodata]="applyNodata || showNoData"
		(buttonEventUpdate)="updateChartData($event)"
	>
	</app-days-filter-r10>
	<app-loader [showLoader]="showLoad"></app-loader>

	<div *ngIf="!showLoad">
		<div class="chart">
			<!-- chart -->
			<div *ngIf="chartConfig && chartdata.length && hasData && !showNoData">
				<app-generic-chart [configuration]="chartConfig" [data]="chartdata" [colorPalette]="colorPalette">
				</app-generic-chart>
			</div>
			<!-- no data container -->
			<div *ngIf="(!chartdata.length && !hasData) || showNoData" class="no-data-container">
				<h3 class="message">{{ nodatamessage }}</h3>
			</div>
			<!-- custom legends-->
			<div
				class="custom-legend"
				*ngIf="radioButtonsEnabled"
				[ngClass]="{ inactive: (!chartdata.length && !hasData) || showNoData }"
			>
				<!-- check buttons section header -->
				<div class="checkbox-section-name" *ngIf="seriesviewconfiguration.checkboxGroupSectionName">
					{{ seriesviewconfiguration.checkboxGroupSectionName }}
				</div>
				<!-- checkboxes -->
				<div class="checkbox-group-container" *ngIf="seriesviewconfiguration.checkboxButtons">
					<label
						for="{{ nameSpace }}-checkbox-{{ button.seriesId }}"
						class="checkbox-container {{ button.color }}"
						*ngFor="let button of seriesviewconfiguration.checkboxButtons"
					>
						<input
							type="checkbox"
							id="{{ nameSpace }}-checkbox-{{ button.seriesId }}"
							value="{{ button.seriesId }}"
							[checked]="button.visible"
							(change)="toggleSeriesVisiblityByCheckbox($event.target.value)"
						/>
						<span class="checkbox-button"></span>
						<span class="checkbox-text">{{ button.displayName }}</span>
					</label>
				</div>

				<!-- radion buttons with sections -->
				<div class="section-name" *ngIf="seriesviewconfiguration.radioGroupSectionName">
					{{ seriesviewconfiguration.radioGroupSectionName }}
				</div>
				<div
					class="radio-container {{ radioButton.color }}"
					*ngFor="let radioButton of seriesviewconfiguration['radioButtonGroup']; let radioButtonId = index"
				>
					<label for="{{ nameSpace }}-radio-button-{{ radioButtonId }}">
						<input
							id="{{ nameSpace }}-radio-button-{{ radioButtonId }}"
							type="radio"
							name="{{ nameSpace }}-button-group"
							[value]="radioButtonId"
							[checked]="selectedRadioButtonId === radioButtonId"
							(change)="updateSeriesVisibilityByRadioButton($event.target.value)"
						/>
						<span
							class="radio-text"
							appTooltip
							[attr.title]="radioButton.title"
							data-size="small"
							[options]="tooltipOptions"
							>{{ radioButton.displayName }}</span
						>
					</label>
				</div>
			</div>
		</div>
	</div>
</div>
